import React from 'react';

import { Sparkles } from 'lucide-react';

import Pill from 'common/common/Pill';
import LazyLoadedImage from 'common/LazyLoadedImage';
import { H2, Span } from 'common/ui/Text';
import styles from 'css-module/components/www/_PricingV4.module.scss';

import PricingV4CardFeature from './PricingV4CardFeature';

import AutopilotRobot from 'img/landing/autopilot-robot.svg';

export default function PricingV4AutopilotCard() {
  return (
    <div className={styles.pricingV4AutopilotCard}>
      <div className={styles.autopilotCard}>
        <div className={styles.autopilotCardTop}>
          <Pill prefixIcon={<Sparkles size={12} />}>New</Pill>
          <H2 className={styles.autopilotCardTitle} variant="headingLg">
            Autopilot AI is included in{' '}
            <Span className={styles.autopilotCardAllPlans} variant="headingLg">
              all&nbsp;plans
            </Span>
          </H2>
          <Span className={styles.autopilotCardSubtitle}>
            Capture feedback in all of your customer&nbsp;communication
          </Span>
        </div>
        <ul className={styles.autopilotCardFeatures}>
          <PricingV4CardFeature feature="Unlimited feedback discovery" />
          <PricingV4CardFeature feature="Unlimited feedback sources" />
          <PricingV4CardFeature feature="Automatic deduplication" />
        </ul>
        <LazyLoadedImage
          alt="Autopilot robot"
          className={styles.autopilotCardRobot}
          loading="eager"
          src={AutopilotRobot}
        />
      </div>
    </div>
  );
}
